var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dev-space"},[_c('div',{staticClass:"content"},[_c('form-box',{attrs:{"title":"My title","fields":_vm.fields}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }